export default "__VITE_ASSET__ee07f942__"